module.exports = __webpack_public_path__ + "@/assets/img/ingreso-admision.6d62df3f.svg";